import { gql } from 'apollo-boost'

export const QUERY_CHECK_MAINTENANCE = gql`
  query checkMaintenance {
    maintenance(limit: 1, order_by: {effective_date: asc}) {
      effective_date
      message
      effective_state
    }
  } 
`
